import {
  Container, Paper, Typography
} from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import React, { ReactElement } from "react";
import { globalStyles } from "../../../assets/globalStyles";
import MessstellenActionheader from "./actionheader";
import MessstellenEdit from "./edit";
import MessstellenGrid from "./grid";
import { useStyles } from "./messstellenStyles";

export default function Messstellen(): ReactElement {

  const classes = {
    ...useStyles(),
    ...globalStyles(),
  };


  return (
    <React.Fragment>
      <Container maxWidth={false} style={{ marginTop: "10px" }}>
        <Grid container md={12} spacing={2} style={{ marginBottom: "10px" }}>
          <Grid item md={3} />
          <Grid item md={6}>
            <Typography color="primary" variant="h5">
              Verwaltung Messstellen
            </Typography>
          </Grid>
        </Grid>
      </Container>
      <MessstellenEdit />
      <Paper className={classes.paper} style={{ marginLeft: "24px", marginRight: "24px" }}>
        <MessstellenActionheader />
        <Grid container spacing={2} style={{ marginBottom: "20px" }}>
          <MessstellenGrid />
        </Grid>
      </Paper>
      
    </React.Fragment>
  );
}
